import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useErrorContext } from './../../components/messages/ErrorBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';
import { useLocale } from './../../components/special/LanguageProvider';
import { apiGetCall, apiPostCall, isResultOk } from './../../components/special/apiCall';
import RowButtons from './../../components/button/RowButtons';
import RowChangeButton from './../../components/button/RowChangeButton';
import RowDeleteButton from './../../components/button/RowDeleteButton';
import ListTable from './../../components/form/ListTable';
import ListHeader from 'components/form/ListHeader';
import TextDate from './../../components/text/TextDate';
import TextAmount from './../../components/text/TextAmount';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;
 
export const ActionCostList = ({})  => {
  const [list, setList] = useState([]);  
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState(null);

  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();
  const { t } = useLocale();
  
  const loadList = async () =>{    
    const data = await apiGetCall(BASE_URL + '/admin/actioncost/summary/');
    if (isResultOk(data, setListError, true)){
      setList(data);
    }    
    setListLoading(false);
  }

  useEffect(() => {
    loadList();
  }, []);


  const onDeleteClick = async (transactionGroupID) => {
    setIsPageLoading(true);
    const data = await apiPostCall(BASE_URL + '/admin/actioncost/remove', {itemID : transactionGroupID});    
    if (isResultOk(data, setCheckErrorItems)){      
      await loadList();
    }
    setIsPageLoading(false);    
  }


  return (    
    <div>      
      <ListHeader title={t("Fastur kostnaður")}/>              
      <div className="text-right"><Link to="/admin/actioncosts/edit?new=true" className="no-print button gray-light icon-plus pointer-edit text-14">{t("Stofna fastan kostnað")}</Link></div>
      <ListTable
          error = {listError}
          isLoading = {listLoading}
          list = {list}
          colsettings = {['10%', '28%', '30%', '10%', '5%']}
          headers = {[
            t("Gildir frá"),
            t("Tengt við aðgerð"),
            t("Færslulykill"),
            <div className="text-right">{t("Upphæð")}</div>,                        
            ""
          ]}
          columns = {[
            (item) => <TextDate value={item.costDate}/>,
            (item) => <>{item.actionName} <small>({item.actionID})</small></>,
            (item) => <>{item.transactionKeyName} <small>({item.transactionKey})</small></>,
            (item) => <div className="text-right"><TextAmount value={item.amount}/></div>,
            (item) => (<RowButtons>
                        <RowDeleteButton onClick={() => onDeleteClick(item.actionCostID)}/>
                        <RowChangeButton link={"/admin/actioncosts/edit?actioncostid=" + item.actionCostID}/>                    
                      </RowButtons>),
          ]}

      />
  </div>
  );
};
        
